import moment from 'moment';
import axiosInstance from '../axios';
import { rejectError } from '../helper';

export default {
  state: {
    usage: [],
    aggregated: {},
  },
  getters: {
    resourceTransferredBytes: state => (id) => {
      const key = `cdn/Endpoint/${id}`;
      if (!(key in state.aggregated)) {
        return 0;
      }
      return state.aggregated[key].transferredBytes;
    },
    resourceCachedBytes: state => (id) => {
      const key = `cdn/Endpoint/${id}`;
      if (!(key in state.aggregated)) {
        return 0;
      }
      return state.aggregated[key].cached;
    },
    totalTransferred(state) {
      let total = 0;
      state.usage.forEach((item) => {
        if (item.type === 'CDN:DataTransferOutBytes') {
          total += item.quantity;
        }
      });
      return total;
    },
    totalCached(state) {
      let total = 0;
      state.usage.forEach((item) => {
        if (item.type === 'CDN:CachedDataTransferOutBytes') {
          total += item.quantity;
        }
      });
      return total;
    },
  },
  mutations: {
    updateUsage(state, usage) {
      state.usage = usage;
    },
    aggregated(state) {
      state.usage.forEach((item) => {
        if (!(item.resource_id in state.aggregated)) {
          state.aggregated[item.resource_id] = {
            cached: 0,
            transferredBytes: 0,
          };
        }
        if (item.type === 'CDN:DataTransferOutBytes') {
          state.aggregated[item.resource_id].transferredBytes = item.quantity;
        }
        if (item.type === 'CDN:CachedDataTransferOutBytes') {
          state.aggregated[item.resource_id].cached = item.quantity;
        }
      });
    },
  },
  actions: {
    getUsage({ commit }, query) {
      return axiosInstance({
        method: 'POST',
        url: '/api/3/usage-reports',
        data: {
          query: {
            type: 'CDN',
            start: `${query.start.utc()
              .format('YYYY-MM-DDTHH:mm:ss')}Z`,
            end: `${query.end.utc()
              .format('YYYY-MM-DDTHH:mm:ss')}Z`,
          },
        },
      })
        .then((result) => {
          const { usage } = result.data.data;
          commit('updateUsage', usage);
          return commit('aggregated');
        })
        .catch(error => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    getUsageForTheLastWeek({ commit }, cdnId) {
      function getUsage(start, end) {
        return axiosInstance({
          method: 'POST',
          url: '/api/3/usage-reports',
          data: {
            query: {
              type: 'CDN',
              start,
              end,
            },
          },
        });
      }
      const from = moment().subtract(1, 'weeks');
      let start = '';
      let end = '';
      const queries = [];
      const result = {};
      const order = [];
      for (let i = 0; i <= 6; i += 1) {
        start = `${from.add('1', 'days').format('YYYY-MM-DDT00:00:00')}Z`;
        result[start] = { transferred: 0, cached: 0, date: from.clone().format('DD MMM') };
        order.push(start);
        end = `${from.clone().add('1', 'days').format('YYYY-MM-DDT00:00:00')}Z`;
        queries.push(getUsage(start, end));
      }
      return Promise.all(queries)
        .then((response) => {
          for (let i = 0; i < response.length; i += 1) {
            const r = response[i];
            const { usage } = r.data.data;
            for (let j = 0; j < usage.length; j += 1) {
              const u = usage[j];
              if (u.type === 'CDN:DataTransferOutBytes'
                && u.resource_id === `cdn/Endpoint/${cdnId}`) {
                result[r.data.data.query.start].transferred += u.quantity;
              }
              if (u.type === 'CDN:CachedDataTransferOutBytes'
                && u.resource_id === `cdn/Endpoint/${cdnId}`) {
                result[r.data.data.query.start].cached += u.quantity;
              }
            }
          }
          const res = [];
          for (let i = 0; i < order.length; i += 1) {
            if (result.hasOwnProperty(order[i])) {
              res.push(result[order[i]]);
            }
          }
          return res;
        })
        .catch(error => rejectError(error));
    },
  },
};
